import { cx } from "components/Graphs/utils";
import React from "react";
import { Link } from "react-router-dom";

export type SettingsScope = "personal" | "organization";

export interface SettingsScopeToggleProps {
  activeScope: SettingsScope;
  organizationId?: string;
  personalLabel?: string;
  className?: string;
}

export const SettingsScopeToggle: React.FC<SettingsScopeToggleProps> = ({
  activeScope,
  organizationId,
  personalLabel = "Personal",
  className,
}) => {
  const scopes: Array<{
    id: SettingsScope;
    label: string;
    href: string;
  }> = [
    { id: "personal", label: personalLabel, href: "/settings/account" },
    {
      id: "organization",
      label: "Organization",
      href: organizationId
        ? `/org/${organizationId}/settings`
        : "/org/settings",
    },
  ];

  return (
    <nav
      aria-label="Settings scope"
      className={cx(
        "inline-flex w-fit items-center rounded-md border border-zinc-700 bg-black/20 p-0.5",
        className,
      )}
    >
      {scopes.map((scope) => {
        const isActive = scope.id === activeScope;

        return (
          <Link
            key={scope.id}
            to={scope.href}
            aria-current={isActive ? "page" : undefined}
            className={cx(
              "rounded px-3 py-1.5 text-xs font-semibold outline-none transition-colors",
              "focus-visible:ring-2 focus-visible:ring-highlight/40",
              isActive
                ? "bg-zinc-800 text-white shadow-sm"
                : "text-zinc-400 hover:bg-white/[0.04] hover:text-zinc-100",
            )}
          >
            {scope.label}
          </Link>
        );
      })}
    </nav>
  );
};

SettingsScopeToggle.displayName = "SettingsScopeToggle";

export default SettingsScopeToggle;
